var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoginIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 62,
  height: 63,
  viewBox: "0 0 62 63",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h22.022v5.695H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M58.58 35.548V10.497c0-2.615-2.144-4.755-4.764-4.755H24.032M24.438 52.461l-13.94-.136v4.762c0 1.31-.47 2.5-1.407 3.452-.821.834-2.11 1.429-3.4 1.429s-2.463-.595-3.284-1.429C1.47 59.706 1 58.516 1 57.206c0-2.619 2.11-4.762 4.69-4.762h4.69V17.258",
  stroke: "#0E3474"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.495 14.498a2.12 2.12 0 0 0 0 3.013l3.831 3.857 3.831 3.856a2.086 2.086 0 0 0 2.993 0l2.633-2.651 10.894 6.87c-6.823 10.485-18.316 5.905-26.337-2.05C9.32 19.44 4.77 7.87 15.186 1l6.823 10.967-2.514 2.531z",
  stroke: "#0E3474",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.952 51.806c0-4.14 3.583-7.451 8.063-7.451h20.874c4.48 0 8.063 3.312 8.063 7.451 0 4.14-3.584 7.452-8.063 7.452H32.015c-4.48 0-8.063-3.312-8.063-7.452z",
  stroke: "#FF3F6D"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(31 49)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.422 2.469c.15.136.227.31.227.523l-.024.118 2.367-.516-.351-1.102-2.22.977zm.172.742c-.1.235-.281.367-.547.399l1.227 2.086.937-.68L3.594 3.21zm-.65.399a.644.644 0 0 1-.545-.4L.789 5.017l.938.68L2.945 3.61zm-.577-.5-.015-.118c0-.218.075-.393.226-.523l-2.22-.977L0 2.594l2.367.516zm.297-.703A.627.627 0 0 1 3 2.32c.13 0 .242.028.336.086L3.578 0H2.422l.242 2.407zm8.773.062c.15.136.227.31.227.523l-.024.118 2.367-.516-.351-1.102-2.22.977zm.172.742c-.1.235-.281.367-.547.399l1.227 2.086.937-.68-1.617-1.805zm-.648.399a.644.644 0 0 1-.547-.4l-1.61 1.806.938.68L10.96 3.61zm-.58-.5-.014-.118c0-.218.075-.393.226-.523l-2.218-.977-.36 1.102 2.367.516zm.298-.703a.627.627 0 0 1 .336-.086c.13 0 .242.028.336.086L11.593 0h-1.156l.242 2.407zm8.773.062c.15.136.226.31.226.523l-.023.118 2.367-.516-.351-1.102-2.22.977zm.172.742c-.1.235-.282.367-.547.399l1.226 2.086.938-.68-1.617-1.805zm-.65.399a.644.644 0 0 1-.546-.4l-1.61 1.806.938.68 1.219-2.086zm-.577-.5-.016-.118c0-.218.076-.393.227-.523l-2.22-.977-.358 1.102 2.367.516zm.297-.703a.627.627 0 0 1 .336-.086c.13 0 .242.028.336.086L19.608 0h-1.156l.242 2.407z",
  fill: "#0E3474",
  mask: "url(#b)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoginIcon);
export default ForwardRef;